import React, { FunctionComponent } from 'react';
import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import { Profile as QuizProfile } from '../typings';

type VitaminProfile = {
  name?: string;
  sex?: string;
  age?: string;
  diet?: string;
  profileCombination: number;
  vitaminA: string;
  vitaminC: string;
  vitaminE: string;
  zinc: string;
  calcium: string;
  vitaminD: string;
  selenium: string;
  magnesium: string;
  biotin: string;
  folate: string;
  vitaminB12: string;
  omega3: string;
  vitaminB6?: string;
  iron?: string;
};

interface ProfileProps {
  profile: QuizProfile;
}

const labels: any = {
  vitaminA: 'Vitamin A',
  vitaminC: 'Vitamin C',
  zinc: 'Zinc',
  calcium: 'Calcium',
  folate: 'Folate',
  selenium: 'Selenium',
  vitaminE: 'Vitamin E',
  vitaminD: 'Vitamin D',
  vitaminB12: 'Vitamin B12',
  magnesium: 'Magnesium',
  biotin: 'Biotin',
  iron: 'Iron',
  omega3: 'Omega3',
  vitaminB6: 'Vitamin B6'
};
const measurement: any = {
  vitaminA: 'ug',
  vitaminC: 'mg',
  zinc: 'mg',
  calcium: 'mg',
  folate: 'ug',
  selenium: 'mg',
  vitaminE: 'mg',
  vitaminD: 'ug',
  vitaminB12: 'ug',
  magnesium: 'mg',
  biotin: 'ug',
  iron: 'mg',
  omega3: 'mg',
  vitaminB6: 'mg'
};

export const getProduct = (obj: any): VitaminProfile => {
  const [selection] = quizProfiles.filter(
    (quizProfile) => quizProfile.sex === obj.sex && quizProfile.age === obj.age && quizProfile.diet === obj.diet
  );
  const [selectedProfile] = vitaminProfiles.filter(
    (vitaminProfile) => vitaminProfile.profileCombination === selection.profileCombination
  );
  return selectedProfile;
};

const Profile: FunctionComponent<ProfileProps> = ({ profile }: ProfileProps) => (
  <Box>
    <SimpleGrid columns={2} spacing={5} py='5'>
      {Object.entries(getProduct(profile)).map(([key, val]) => {
        if (key === 'profileCombination') return;

        // eslint-disable-next-line consistent-return
        return (
          <Box key={key}>
            <Text>
              {labels[key]}:{'  '}
              <Text as='samp'>
                {val}
                {measurement[key]}
              </Text>
            </Text>
          </Box>
        );
      })}
    </SimpleGrid>
    {/* <Image src='https://via.placeholder.com/150'/> */}
  </Box>
);

export default Profile;

const quizProfiles: QuizProfile[] = [
  {
    sex: 'male',
    age: 'child',
    diet: 'poor',
    profileCombination: 3
  },
  {
    sex: 'male',
    age: 'child',
    diet: 'average',
    profileCombination: 2
  },
  {
    sex: 'male',
    age: 'child',
    diet: 'great',
    profileCombination: 1
  },
  {
    sex: 'male',
    age: 'teen',
    diet: 'poor',
    profileCombination: 6
  },
  {
    sex: 'male',
    age: 'teen',
    diet: 'average',
    profileCombination: 5
  },
  {
    sex: 'male',
    age: 'teen',
    diet: 'great',
    profileCombination: 4
  },
  {
    sex: 'male',
    age: '20-40',
    diet: 'poor',
    profileCombination: 12
  },
  {
    sex: 'male',
    age: '20-40',
    diet: 'average',
    profileCombination: 11
  },
  {
    sex: 'male',
    age: '20-40',
    diet: 'great',
    profileCombination: 10
  },
  {
    sex: 'male',
    age: '40-55',
    diet: 'poor',
    profileCombination: 12
  },
  {
    sex: 'male',
    age: '40-55',
    diet: 'average',
    profileCombination: 11
  },
  {
    sex: 'male',
    age: '40-55',
    diet: 'great',
    profileCombination: 10
  },
  {
    sex: 'male',
    age: '55+',
    diet: 'poor',
    profileCombination: 18
  },
  {
    sex: 'male',
    age: '55+',
    diet: 'average',
    profileCombination: 17
  },
  {
    sex: 'male',
    age: '55+',
    diet: 'great',
    profileCombination: 16
  },
  {
    sex: 'female',
    age: 'child',
    diet: 'poor',
    profileCombination: 3
  },
  {
    sex: 'female',
    age: 'child',
    diet: 'average',
    profileCombination: 2
  },
  {
    sex: 'female',
    age: 'child',
    diet: 'great',
    profileCombination: 1
  },
  {
    sex: 'female',
    age: 'teen',
    diet: 'poor',
    profileCombination: 9
  },
  {
    sex: 'female',
    age: 'teen',
    diet: 'average',
    profileCombination: 8
  },
  {
    sex: 'female',
    age: 'teen',
    diet: 'great',
    profileCombination: 7
  },
  {
    sex: 'female',
    age: '20-40',
    diet: 'poor',
    profileCombination: 15
  },
  {
    sex: 'female',
    age: '20-40',
    diet: 'average',
    profileCombination: 14
  },
  {
    sex: 'female',
    age: '20-40',
    diet: 'great',
    profileCombination: 13
  },
  {
    sex: 'female',
    age: '40-55',
    diet: 'poor',
    profileCombination: 15
  },
  {
    sex: 'female',
    age: '40-55',
    diet: 'average',
    profileCombination: 14
  },
  {
    sex: 'female',
    age: '40-55',
    diet: 'great',
    profileCombination: 13
  },
  {
    sex: 'female',
    age: '55+',
    diet: 'poor',
    profileCombination: 21
  },
  {
    sex: 'female',
    age: '55+',
    diet: 'average',
    profileCombination: 20
  },
  {
    sex: 'female',
    age: '55+',
    diet: 'great',
    profileCombination: 19
  }
];

const vitaminProfiles: VitaminProfile[] = [
  {
    profileCombination: 1,
    vitaminA: '750',
    vitaminC: '30',
    zinc: '2.5',
    calcium: '230',
    folate: '200',
    selenium: '0',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '1.2',
    magnesium: '15',
    vitaminB6: '0.6',
    biotin: '7.5',
    iron: '2',
    omega3: '0'
  },
  {
    profileCombination: 2,
    vitaminA: '750',
    vitaminC: '30',
    zinc: '2.5',
    calcium: '230',
    folate: '200',
    selenium: '0',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '1.2',
    magnesium: '15',
    vitaminB6: '0.6',
    biotin: '7.5',
    iron: '2',
    omega3: '0'
  },
  {
    profileCombination: 3,
    vitaminA: '750',
    vitaminC: '30',
    zinc: '2.5',
    calcium: '230',
    folate: '200',
    selenium: '0',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '1.2',
    magnesium: '15',
    vitaminB6: '0.6',
    biotin: '7.5',
    iron: '2',
    omega3: '0'
  },
  {
    profileCombination: 4,
    vitaminA: '500',
    vitaminC: '50',
    zinc: '5',
    calcium: '220',
    folate: '300',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 5,
    vitaminA: '1000',
    vitaminC: '100',
    zinc: '10',
    calcium: '440',
    folate: '600',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 6,
    vitaminA: '1470',
    vitaminC: '150',
    zinc: '16',
    calcium: '400',
    folate: '400',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '5',
    omega3: '1000'
  },
  {
    profileCombination: 7,
    vitaminA: '500',
    vitaminC: '50',
    zinc: '5',
    calcium: '220',
    folate: '300',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '10',
    omega3: '1000'
  },
  {
    profileCombination: 8,
    vitaminA: '1000',
    vitaminC: '100',
    zinc: '10',
    calcium: '440',
    folate: '600',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '15',
    omega3: '1000'
  },
  {
    profileCombination: 9,
    vitaminA: '1235',
    vitaminC: '125',
    zinc: '13',
    calcium: '420',
    folate: '500',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '10',
    omega3: '1000'
  },
  {
    profileCombination: 10,
    vitaminA: '500',
    vitaminC: '50',
    zinc: '5',
    calcium: '220',
    folate: '300',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 11,
    vitaminA: '1235',
    vitaminC: '125',
    zinc: '13',
    calcium: '420',
    folate: '500',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 12,
    vitaminA: '1470',
    vitaminC: '150',
    zinc: '16',
    calcium: '400',
    folate: '400',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 13,
    vitaminA: '500',
    vitaminC: '50',
    zinc: '5',
    calcium: '220',
    folate: '300',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '15',
    omega3: '1000'
  },
  {
    profileCombination: 14,
    vitaminA: '1000',
    vitaminC: '100',
    zinc: '10',
    calcium: '440',
    folate: '600',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '5',
    vitaminB12: '2.5',
    magnesium: '80',
    vitaminB6: '1',
    biotin: '20',
    iron: '15',
    omega3: '1000'
  },
  {
    profileCombination: 15,
    vitaminA: '1235',
    vitaminC: '125',
    zinc: '13',
    calcium: '420',
    folate: '500',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '10',
    omega3: '1000'
  },
  {
    profileCombination: 16,
    vitaminA: '735',
    vitaminC: '75',
    zinc: '8',
    calcium: '200',
    folate: '200',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 17,
    vitaminA: '1235',
    vitaminC: '125',
    zinc: '13',
    calcium: '420',
    folate: '500',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 18,
    vitaminA: '1470',
    vitaminC: '150',
    zinc: '16',
    calcium: '400',
    folate: '400',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '5',
    omega3: '1000'
  },
  {
    profileCombination: 19,
    vitaminA: '500',
    vitaminC: '50',
    zinc: '5',
    calcium: '220',
    folate: '300',
    selenium: '15',
    vitaminE: '5',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 20,
    vitaminA: '1000',
    vitaminC: '100',
    zinc: '10',
    calcium: '440',
    folate: '600',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '0',
    omega3: '1000'
  },
  {
    profileCombination: 21,
    vitaminA: '1235',
    vitaminC: '125',
    zinc: '13',
    calcium: '420',
    folate: '500',
    selenium: '30',
    vitaminE: '10',
    vitaminD: '10',
    vitaminB12: '5',
    magnesium: '160',
    vitaminB6: '2',
    biotin: '40',
    iron: '5',
    omega3: '1000'
  }
];
